import React from 'react';
import PropTypes from 'prop-types';
import { DropZoneContainer, DropZoneIcon, DropZoneText, DropZoneSubText, HiddenInput } from './components/DragAndDropStyles';
import { useDragAndDrop } from './hooks/useDragAndDrop';
import Icon from '../../atoms/Icon';

const DragAndDrop = ({
  onFileDrop,
  accept,
  multiple,
  title,
  subtitle,
}) => {
  const { isDragging, inputRef, handlers, handleFileSelect } = useDragAndDrop({ onFileDrop });

  return (
    <DropZoneContainer isDragging={isDragging} {...handlers}>
      <HiddenInput
        type="file"
        ref={inputRef}
        onChange={handleFileSelect}
        accept={accept}
        multiple={multiple}
      />
      <DropZoneIcon>
        <Icon className="fas fa-cloud-upload" size="lg" color="inherit" />
      </DropZoneIcon>
      <DropZoneText>{title}</DropZoneText>
      {subtitle && <DropZoneSubText>{subtitle}</DropZoneSubText>}
    </DropZoneContainer>
  );
};

DragAndDrop.propTypes = {
  onFileDrop: PropTypes.func.isRequired,
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

DragAndDrop.defaultProps = {
  accept: undefined,
  multiple: true,
  title: 'Arraste os arquivos aqui ou clique para selecionar',
  subtitle: undefined,
};

export default DragAndDrop;



// WEBPACK FOOTER //
// ./src/design-system/molecules/DragAndDrop/DragAndDrop.jsx